import { apiRoutes } from '@/constants/api-routes';
import { apiRequest } from './http';
import type { BroadcastDetailView, BroadcastView } from '@/types/api';

export interface CreateBroadcastPayload {
  templateId: string;
  listId: string;
}

export interface SpamCheckResult {
  score: number | null;
  report: string | null;
}

export interface TestSendResult {
  sent: boolean;
  messageId?: string;
}

export const adminBroadcastsService = {
  async list(): Promise<BroadcastView[]> {
    return apiRequest<BroadcastView[]>(apiRoutes.adminBroadcasts.list, { method: 'GET' });
  },

  async getById(id: string): Promise<BroadcastDetailView> {
    return apiRequest<BroadcastDetailView>(apiRoutes.adminBroadcasts.one(id), { method: 'GET' });
  },

  async create(payload: CreateBroadcastPayload): Promise<BroadcastDetailView> {
    return apiRequest<BroadcastDetailView>(apiRoutes.adminBroadcasts.create, {
      method: 'POST',
      body: payload,
    });
  },

  async spamCheck(id: string): Promise<SpamCheckResult> {
    return apiRequest<SpamCheckResult>(apiRoutes.adminBroadcasts.spamCheck(id), { method: 'POST' });
  },

  async test(id: string, email: string): Promise<TestSendResult> {
    return apiRequest<TestSendResult>(apiRoutes.adminBroadcasts.test(id), {
      method: 'POST',
      body: { email },
    });
  },

  async send(id: string): Promise<BroadcastDetailView> {
    return apiRequest<BroadcastDetailView>(apiRoutes.adminBroadcasts.send(id), { method: 'POST' });
  },

  async cancel(id: string): Promise<BroadcastDetailView> {
    return apiRequest<BroadcastDetailView>(apiRoutes.adminBroadcasts.cancel(id), { method: 'POST' });
  },
};
